import styled, { css } from 'styled-components';
import { Button, Col } from 'antd';

interface ActionButtonProps {
	$danger: boolean;
}

export const ActionsInline = styled(Col)`
	display: none;

	@media (min-width: 48rem) {
		display: flex;
		justify-content: center;
	}
`;

export const ActionsMenu = styled(Col)`
	display: flex;

	@media (min-width: 48rem) {
		display: none;
	}
`;

export const ActionButton = styled(Button)<ActionButtonProps>`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 1.5rem;
	height: 1.5rem;
	padding: 0;
	color: ${({ theme }) => theme.palette.primary[600]};

	${({ $danger, theme }) =>
		$danger &&
		css`
			color: ${theme.colors.danger};

			&:hover,
			&:focus {
				color: ${theme.colors.danger};
				opacity: 0.7;
			}
		`}
`;
